module.exports = __webpack_public_path__ + "img/user.f74683a8.svg";